
import axios from "@/utils/axios";

const GET_JOB_DETAILS = 'v4/batch-upload/get-batch-jobdetails-images-png';
const GET_PROMPT_DETAIL ='v4/batch-upload/getTransaction';
const GET_BACKGROUNDS = 'v4/batch-upload/getBackgrounds';
const GENERATE_PROMPT = 'v4/batch-upload/generateMore';
const SET_BACKGROUND = 'v4/batch-upload/setBackground';
const UPLOAD_CSV = 'v4/batch-upload/upload-csv';
const UPDATE_NAME = 'v3/shootsetupjobs/jobName-Update';
const UPLOAD_IMAGE ='v4/batch-upload/upload-job-refrence-image';
const UPSCALE_IMAGES ='v4/batch-upload/confirmBatch';
const UPDATE_BEFORE_GENERATE = 'v4/batch-upload/updateDMSPNG';
const GENERATE_AI = 'v4/batch-upload/triggerBackgroundGeneration';
const MASK_IMAGE_UPLOAD = 'v4/batch-upload/upload-mask-image';
const CSV_DATA = 'v4/batch-upload/genBackgroundData/';
const UPDATE_GEN_BOUNDRY_BOX = 'v4/batch-upload/updateGenerationBoundingBox/';
const FACE_FOR_SWAP ='v4/batch-upload/get-bulk-upload-assets?assetType=FACE_SWAP'
const UPDATE_FACE_SWAP_INFO = "v4/batch-upload/update-reference-url";
const RESET_FACE_SWAP = 'v4/batch-upload/reset-all-settings';
const COLOR_CORRECTION = '/v4/batch-upload/colorCorrection';
const REFERENCE_LIST = `/v5/brandGuide/fetchReferenceList`;
const GET_BULKAIPACKAGELISTING = "/v3/images/getMetadata/bulkAIPackageListing";
const GET_CUSTOM_JOB = "/v4/batch-upload/get-batch-custom-job-detail";
const UPDATE_PROMPT = "/v4/batch-upload//update-prompt";
const UPLOAD_REFERENCE = "/v5/brandGuide/uploadReference";
const GET_BRANDS='/v5/brandGuide/getBrandList';
const GET_FACE_FILTER = "/v4/batch-upload/face-mask-filters";

const UPDATE_BATCH_NAME = 'v4/batch-upload//updateBatchLabel';
const GET_BATCH_COST = "/v4/batch-upload/get-batch-cost";
const GET_JOB_REFERENCE = "/v4/batch-upload/batch-job-instruction-detail";
const GENERATE_PREVIEW = "/v4/shootnewLifestyleImage/updateInstantDownloadImages?eventName=previewGeneration";

const uploadBulkJobCSV = (formData) => axios.post(UPLOAD_CSV, formData);
const fetchAllBatchJobs = (skip=0,batchId='',signal,limit=20) => axios.get(GET_JOB_DETAILS+`?skip=${skip}&limit=${limit}&batchId=${batchId}`,signal);
const fetchPromptDetail = (transactionId='') => axios.get(GET_PROMPT_DETAIL+`?transactionId=${transactionId}`);
const generateMorePrompt = (payload,signal) => axios.post(GENERATE_PROMPT, payload, signal);
const fetchBackgrounds = (imageId,type=null,signal)=> axios.get(`${GET_BACKGROUNDS}/${imageId}`,type, signal);
const savePromptBackground = (payload) => axios.post(SET_BACKGROUND, payload);
const updateJobName = (_id, name) => axios.put(UPDATE_NAME + `?jobId=${_id}&jobName=${name}`);
const uploadReferenceImage = (payload) => axios.post(UPLOAD_IMAGE,payload);
const upscaleImage = (payload) => axios.post(UPSCALE_IMAGES,payload); 
const uploadBeforeGenerateImage = (payload) => axios.post(UPDATE_BEFORE_GENERATE,payload);
const continueGeneration = (payload) => axios.post(GENERATE_AI,payload);
const uploadMaskImage = (payload) => axios.post(MASK_IMAGE_UPLOAD,payload);
const getBatchCsvData = (_id) => axios.get(CSV_DATA + _id);
const updateGenerationBoundryBox = (_id,payload) => axios.post(UPDATE_GEN_BOUNDRY_BOX + _id,payload);
const getFacesForSwap = (skip=0,type="ALL",docId=null) => axios.get(FACE_FOR_SWAP + `&skip=${skip}&limit=5&type=${type}${docId ? '&docId='+docId : ""}`);
const getFaceList = (payload) => axios.get(FACE_FOR_SWAP + payload);
const updateFaceSwapData = (payload) => axios.post(UPDATE_FACE_SWAP_INFO,payload);
const resetImagePromptData = (imageId,batchType) => axios.put(RESET_FACE_SWAP+ `?batchType=${batchType}&imageId=${imageId}`);
const updateImageColor = (payload) => axios.post(COLOR_CORRECTION,payload);
const getReferenceImageList = ({skip=0,imageId=null,searchStr='',brandId='', selectedStyles=[]},signal) => axios.get(REFERENCE_LIST + `?skip=${skip}&limit=20&image_id=${imageId}${searchStr ? '&searchStr=' + searchStr : ''}${brandId ? '&brand_id=' + brandId : ''}${selectedStyles ? '&selectedStyles='+selectedStyles : []}`,signal);
const bulkAIPackageListing = (_id) => axios.get(GET_BULKAIPACKAGELISTING)
const getBatchCustomJob = (payload) => axios.post(GET_CUSTOM_JOB,payload);
const updatePrompt = (payload) =>axios.post(UPDATE_PROMPT,payload);
const uploadReference = (payload) => axios.post(UPLOAD_REFERENCE,payload);
const getBrandList = ({skip=0,limit=10,searchStr=''}) => axios.get(GET_BRANDS + `/${skip}/${limit}?hasEmbedding=true${searchStr ? '&searchStr='+searchStr : ''}`);
const getFaceFilters = () => axios.get(GET_FACE_FILTER);
const updateBatchName = (payload) => axios.put(UPDATE_BATCH_NAME + `?batchId=${payload?.batchId}&batchLabel=${payload?.batchLabel}`)
const getBatchCost = (_id) => axios.get(GET_BATCH_COST+`?batchId=${_id}`)
const getJobReference = (_id) => axios.get(GET_JOB_REFERENCE+`?jobId=${_id}`);
const generatePreview = (_id) => axios.put(`${GENERATE_PREVIEW}&jobId=${_id}`);

export default{
    uploadBulkJobCSV,
    fetchAllBatchJobs,
    fetchPromptDetail,
    fetchBackgrounds,
    generateMorePrompt,
    savePromptBackground,
    updateJobName,
    uploadReferenceImage,
    upscaleImage,
    uploadBeforeGenerateImage,
    continueGeneration,
    uploadMaskImage,
    getBatchCsvData,
    updateGenerationBoundryBox,
    getFacesForSwap,
    updateFaceSwapData,
    resetImagePromptData,
    updateImageColor,
    bulkAIPackageListing,
    getReferenceImageList,
    getBatchCustomJob,
    getFaceList,
    updatePrompt,
    uploadReference,
    getBrandList,
    getFaceFilters,
    updateBatchName,
    getBatchCost,
    getJobReference,
    generatePreview,
}